import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';

const API = process.env.REACT_APP_API_URL;
const SLUG = 'pump-sales-service';
// Fixed slots: img[0]=product (right of intro), img[1]=install (beside brands), img[2]=repair (beside process), img[3]=showroom strip
// Additional: img[4+]

const BRANDS = ['Kirloskar', 'CRI', 'Grundfos', 'Texmo', 'V-Guard'];

const PumpSalesService = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/services/${SLUG}`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="sp-loading"><div className="sp-spinner" /><p>Loading...</p></div>;
  if (!data) return null;

  const imgs = data.images || [];
  const heroStyle = data.bannerUrl ? { backgroundImage: `url(${data.bannerUrl})` } : {};
  const heroClass = `service-hero${data.bannerUrl ? '' : ' service-hero-gradient'}`;

  return (
    <div className="service-page">
      <div className={heroClass} style={heroStyle}>
        <div className="service-hero-content">
          {!data.bannerUrl && <div className="service-hero-icon">{data.icon}</div>}
          <h1>{data.title}</h1>
          <p>{data.subtitle}</p>
        </div>
      </div>

      <div className="ps-body">
        <div className="breadcrumb">
          <Link to="/">Home</Link> &rsaquo; <Link to="/">Services</Link> &rsaquo; <span>{data.title}</span>
        </div>

        {/* Intro + img[0] product shot — grid only if image uploaded */}
        {imgs[0] ? (
          <div className="ps-intro-wrap">
            <div className="ps-intro-text">
              <p>{data.intro}</p>
              <p>{data.intro2}</p>
            </div>
            <div className="ps-product-img">
              <img src={imgs[0].url} alt={imgs[0].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="ps-intro-text-only">
            <p>{data.intro}</p>
            <p>{data.intro2}</p>
          </div>
        )}

        {/* Brands + img[1] installation photo — grid only if image uploaded */}
        {imgs[1] ? (
          <div className="ps-brands-wrap">
            <div className="ps-brands-left">
              <h3>Brands We Supply &amp; Service</h3>
              <div className="ps-brands">
                {BRANDS.map((b) => <span className="ps-brand-badge" key={b}>{b}</span>)}
              </div>
            </div>
            <div className="ps-install-img">
              <img src={imgs[1].url} alt={imgs[1].caption || data.title} />
            </div>
          </div>
        ) : (
          <div className="ps-brands-solo">
            <h3>Brands We Supply &amp; Service</h3>
            <div className="ps-brands">
              {BRANDS.map((b) => <span className="ps-brand-badge" key={b}>{b}</span>)}
            </div>
          </div>
        )}

        {/* Process steps + img[2] service photo — grid only if image uploaded */}
        {data.processSteps && data.processSteps.length > 0 && (
          imgs[2] ? (
            <div className="ps-steps-wrap">
              <div className="ps-steps">
                <h2>{data.processTitle}</h2>
                <div className="ps-steps-grid">
                  {data.processSteps.map((s) => (
                    <div className="ps-step" key={s.step}>
                      <div className="ps-step-num">{s.step}</div>
                      <h4>{s.title}</h4>
                      <p>{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="ps-service-img">
                <img src={imgs[2].url} alt={imgs[2].caption || data.title} />
              </div>
            </div>
          ) : (
            <div className="ps-steps-solo">
              <h2>{data.processTitle}</h2>
              <div className="ps-steps-grid">
                {data.processSteps.map((s) => (
                  <div className="ps-step" key={s.step}>
                    <div className="ps-step-num">{s.step}</div>
                    <h4>{s.title}</h4>
                    <p>{s.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )
        )}

        {/* img[3]: showroom strip — only if uploaded */}
        {imgs[3] && (
          <div className="ps-showroom-strip">
            <img src={imgs[3].url} alt={imgs[3].caption || data.title} />
          </div>
        )}

        {data.features && data.features.length > 0 && (
          <div className="ps-catalog-grid">
            <h2>{data.featuresTitle}</h2>
            {data.features.map((f) => (
              <div className="ps-cat-card" key={f.title}>
                <div className="ps-cat-icon">{f.icon}</div>
                <h4>{f.title}</h4>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        )}

        {data.specs && data.specs.length > 0 && (
          <div className="ps-specs">
            <h2>{data.specsTitle}</h2>
            <table><tbody>
              {data.specs.map((row, i) => <tr key={i}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
            </tbody></table>
          </div>
        )}

        {imgs.length > 4 && (
          <div className="sp-additional-images">
            <h3>Additional Service Images</h3>
            <div className="sp-additional-grid">
              {imgs.slice(4).map((img) => (
                <div className="sp-additional-card" key={img.filename}>
                  <img src={img.url} alt={img.caption || data.title} />
                  {img.caption && <p>{img.caption}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="sp-cta">
          <h2>{data.ctaTitle}</h2>
          <p>{data.ctaText}</p>
          <a href="/#contact" className="sp-cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </div>
  );
};

export default PumpSalesService;
